import { isEuEnv } from '@mb/lib';
const configGlobal = typeof SEARCH_CONFIG !== 'undefined' ? SEARCH_CONFIG : {};

const fallbackApiURL = isEuEnv
  ? 'https://search.materialbank.eu/v2'
  : 'https://search.materialbank.com/v2';

const fallbackSiteId = isEuEnv
  ? 'materialbank-eu_product'
  : 'materialbank_product';

export const apiCatalogURL =
  configGlobal?.product?.siteUrl?.replace(/\/$/, '') || fallbackApiURL;

export const bridgeSettings = {
  siteUrl: apiCatalogURL,
  siteId: configGlobal?.product?.siteId || fallbackSiteId,
};
